export default __webpack_public_path__ + "static/media/CNBC TV18.cfd2efea.png";